import type { Model } from '@patsnap/tahiti-core';
import type { Permission } from '../types';

export const PermissionModel = Symbol.for('PermissionModel');

export interface PermissionModel extends Model<Permission> {}
